import { sidebarDefaultPanelsList } from './sidebar-map';

export function createOnlineSidebarDirective(UIExtension) {
    const { modular, Directive, UIEvents, shared: { attachContextMenuEvent }, PDFViewCtrl: { DeviceInfo: { isMobile } } } = UIExtension;
    const module = modular.module('online');

    class OnlineSidebarDirective extends Directive {
        static getName() {
            return 'sidebar';
        }
        init(component) {
            super.init(component);
            component._bindContextmenuEvent = function () {
                const ele = this.element.querySelector('.fv__ui-sidebar-ctls');
                this.addDestroyHook(attachContextMenuEvent(ele, e => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.isCollaborationMode) return;
                    // When current doc is a portfolio doc.
                    if (this.isPortfolioDoc()) {
                        return;
                    }
                    if (!this.sidebarContextmenu) {
                        const root = this.getRoot();
                        root.append(`<sidebar-contextmenu></sidebar-contextmenu>`);
                        this.sidebarContextmenu = root.querySelector('@sidebar-contextmenu');;
                    }
                    this.sidebarContextmenu.showContextmenu(e);
                }));
                const shortcuts = [
                    ['F4', () => {
                        this.toggle();
                    }]
                ];
                const pdfUI = this.getPDFUI();
                this.addDestroyHook(()=> {
                    shortcuts.forEach(shortcut => {
                        pdfUI.pdfViewer.offShortcutKey(...shortcut);
                    })
                })
                shortcuts.forEach(shortcut => {
                    pdfUI.pdfViewer.onShortcutKey(...shortcut);
                })
            };
            component.toggleCollaborationMode= function(status) {
                // only collaboration mode do it, because sidebar will reset when openFileSuccess
                if (status) {
                    this.isCollaborationMode = true;
                    const children = this.children();
                    const whiteList = ['sidebar-thumbnail-panel', 'comment-list-sidebar-panel', 'sidebar-attachment'];
                    children.forEach(child => {
                        if (!whiteList.includes(child.name)) {
                            child.hide();
                        } else {
                            child.show();
                        }
                    });
                } else {
                    this.isCollaborationMode = false;
                    const children = this.children();
                    children.forEach(child => {
                        if (sidebarDefaultPanelsList.includes(child.name)) {
                            child.show();
                        }
                    });
                    if (this.isPortfolioDoc()) {
                        const attachmentChild = children.find(child => child.name === 'sidebar-attachment');
                        attachmentChild.hide();
                    }
                }
            };
            component.resetPanels = function() {
                const children = this.children();
                const isPortfolioDoc = this.isPortfolioDoc();
                for (const child of children) {
                    if (child.name === 'sidebar-attachment' && isPortfolioDoc) {
                        child.hide();
                        continue;
                    }
                    if (!sidebarDefaultPanelsList.includes(child.name)&&!child['plugin-id']) {
                        child.hide();
                    } else {
                        child.show();
                    }
                }
                this.collapse();
            }
            this.addDestroyHook(
                this.getPDFUI().addUIEventListener({
                    [UIEvents.toggleNavigationPanels]: () => {
                        component.toggle();
                    },
                    [UIEvents.resetNavigationPanels]: () => {
                        component.resetPanels();
                    },
                    [UIEvents.toggleCollaborationMode]: (status) => {
                        component.toggleCollaborationMode(status);
                    },
                })
            )
        }
        componentMounted() {
            const component = this.component;
            if (!isMobile) {
                component._bindContextmenuEvent();
            }
        }
    }

    module.getRegistry().registerDirective(OnlineSidebarDirective);
}